(() => {
  if (customElements.get('info-cards')) {
    return;
  }

  class InfoCards extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
      this.mobileBreakpoint = '(max-width: 750px)';
      this.currentBreakpoint;
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.initSlider();

        window.addEventListener('resize', this.initSlider.bind(this));
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      if (window.matchMedia(this.mobileBreakpoint).matches) {
        if (this.currentBreakpoint === 'mobile') return;

        this.options = {
          slidesPerView: 1,
          loop: true,
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
        };

        this.currentBreakpoint = 'mobile';
      } else {
        if (this.currentBreakpoint === 'desktop') return;

        this.options = {
          slidesPerView: 2,
          spaceBetween: 53,
          loop: true,
          breakpoints: {
            900: {
              slidesPerView: 3,
            },
            1300: {
              slidesPerView: 4,
            },
          },
        };

        this.currentBreakpoint = 'desktop';
      }

      if (this.hasAttribute('data-autoplay')) {
        this.options.autoplay = {
          delay: this.dataset.autoplaySpeed,
        };
      }

      if (this.slider) this.slider.destroy();

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('info-cards', InfoCards);
})();
